// Pure predicates for the TR-1100/1101 single-account lifecycle dialogs (feature 011).
// Kept out of the dialog component files so React Fast Refresh stays component-only, and so
// the rules are unit-testable in isolation.

/**
 * Exact control-text match for the TR-1101 delete guard: byte-for-byte, case-sensitive,
 * NO whitespace normalisation (contrast `DeleteClassDialog`, which trims and collapses).
 * TR-1101 R3 / feature 036 FR-017 forbid normalisation — the student login is exact
 * by construction, and the server re-checks the same way.
 */
export function deleteControlTextMatches(typed: string, login: string): boolean {
  return typed === login
}

/**
 * The restore force-password-change checkbox is locked (checked, disabled) exactly when the
 * account never completed a first login — the backend then re-arms the flag mandatorily and
 * ignores the request value (feature 036 FR-012 / restore ruling D17). A null `last_login`
 * on the roster row is that signal (the wire type says `string`, but a never-logged-in
 * account carries null at runtime — see specs/011 research).
 */
export function restoreCheckboxLocked(lastLogin: string | null): boolean {
  return lastLogin === null
}
